import { USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Button, Grid, Icon } from 'semantic-ui-react';
import RestrictedView from 'shared/RestrictedView';
import { useSelector } from 'react-redux';

const SequencesToolbar = () => {
    const isReadingSequenceProductLimits = useSelector(state => state.sequences.isReadingSequenceProductLimits);

    return (
        <Grid>
            <Grid.Column width={3} floated='right'>
                <RestrictedView type='disabled' productPermission={PRODUCT_PERMISSIONS.SETTINGS_SEQUENCES} userPermission={USER_PERMISSIONS.SEQUENCES_ADD}>
                <Button disabled={isReadingSequenceProductLimits} as={NavLink} primary floated='right' to={`/settings/sequences/create`} className='AddImportButton'>
                    <Icon name='plus' /> Sequence
                </Button>
                </RestrictedView>
            </Grid.Column>
        </Grid>
    );
}

export default SequencesToolbar;
